import { buildSelector } from '@/shared/lib/store';

export const [useUserName] = buildSelector(
    (state) => state.viewer?.data?.username || '',
);
